var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaperPlaneCelebrationSvg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#F4F4F4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2435_13925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5031 63.9678C17.1512 63.9678 16.7992 63.8336 16.5308 63.5651C15.9938 63.0281 15.9938 62.1575 16.5308 61.6204L28.8753 49.2758C29.4124 48.7388 30.283 48.7388 30.82 49.2758C31.357 49.8128 31.357 50.6834 30.82 51.2204L18.4754 63.5651C18.2068 63.8336 17.855 63.9678 17.5031 63.9678Z",
    fill: "#004080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7863 49.2441L16.5002 63.53C16.5106 63.5411 16.5199 63.5528 16.5307 63.5637C16.7992 63.8322 17.1511 63.9664 17.503 63.9664C17.8549 63.9664 18.2068 63.8322 18.4753 63.5637L30.8199 51.219C31.3569 50.682 31.3569 49.8114 30.8199 49.2744C30.809 49.2637 30.7973 49.2544 30.7863 49.2441Z",
    fill: "#004080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3385 63.967C26.9866 63.967 26.6347 63.8327 26.3663 63.5642C25.8292 63.0272 25.8292 62.1566 26.3663 61.6196L34.7101 53.2758C35.247 52.7388 36.1177 52.7388 36.6547 53.2758C37.1917 53.8128 37.1917 54.6834 36.6547 55.2204L28.3109 63.5642C28.0423 63.8327 27.6905 63.967 27.3385 63.967Z",
    fill: "#004080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.375 54.259C17.0231 54.259 16.6712 54.1248 16.4028 53.8563C15.8657 53.3193 15.8657 52.4487 16.4028 51.9116L24.8743 43.4399C25.4113 42.9029 26.282 42.9029 26.819 43.4399C27.356 43.9769 27.356 44.8475 26.819 45.3845L18.3474 53.8563C18.0789 54.1247 17.727 54.259 17.375 54.259Z",
    fill: "#004080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5971 17.4341C62.2479 17.0849 61.7383 16.9497 61.2619 17.08L22.7808 27.6098C22.2472 27.7559 21.853 28.2075 21.7806 28.756C21.7081 29.3045 21.9713 29.843 22.4487 30.1227L34.6593 36.896L43.1352 45.3719L49.9085 57.5827C50.1573 58.0075 50.6112 58.2628 51.0946 58.2628C51.1544 58.2628 51.2148 58.2589 51.2752 58.2509C51.8236 58.1785 52.2752 57.7843 52.4213 57.2506L62.9511 18.7694C63.0814 18.2929 62.9464 17.7832 62.5971 17.4341Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5972 17.4336L38.8972 41.1334L43.1352 45.3714L49.9086 57.5822C50.1574 58.007 50.6112 58.2623 51.0946 58.2623C51.1544 58.2623 51.2148 58.2584 51.2752 58.2504C51.8236 58.178 52.2753 57.7838 52.4213 57.2501L62.9511 18.7689C63.0815 18.2925 62.9464 17.7828 62.5972 17.4336Z",
    fill: "#287F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5972 17.4336L34.6593 36.8955L32.3512 45.9801C32.2143 46.4601 32.3483 46.9767 32.7012 47.3296C32.9627 47.5912 33.3139 47.7324 33.6736 47.7324C33.7994 47.7324 33.9263 47.7151 34.0506 47.6796L43.1351 45.3713L62.5972 17.4336Z",
    fill: "#36BA5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.701 47.3295L32.7012 47.3296C32.9627 47.5912 33.314 47.7325 33.6736 47.7325C33.7994 47.7325 33.9263 47.7152 34.0506 47.6797L43.1351 45.3714L62.5971 17.4336L62.5969 17.4338L32.701 47.3295Z",
    fill: "#266336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2435_13925"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    fill: "white",
    transform: "translate(16 17)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlaneCelebrationSvg);
export default __webpack_public_path__ + "static/media/PaperPlaneCelebrationSvg.880cb1e419fed89d40c2eddb5780fa58.svg";
export { ForwardRef as ReactComponent };